import Api from './api';
import { getXAPIEnv, getXUserKey } from '@/plugins/account'

export default {
  GetSurvey () {
    return Api('survey', 'survey/order', 'get', {}, { 'x-api-env': getXAPIEnv(), 'x-user-key': getXUserKey() }, false);
  }
}